import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Vue } from 'vue-class-component';
var GridSquareLayout = /*#__PURE__*/function (_Vue) {
  function GridSquareLayout() {
    _classCallCheck(this, GridSquareLayout);
    return _callSuper(this, GridSquareLayout, arguments);
  }
  _inherits(GridSquareLayout, _Vue);
  return _createClass(GridSquareLayout);
}(Vue);
export { GridSquareLayout as default };